import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CalculatorSearchCar from '@/components/calculator/CalculatorSearchCar.vue';
  import { onMounted, ref } from 'vue';
  import { additionalCosts, carData } from '@/types';
  import { getSession } from '@/indexedDB';
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CalculatorView',
  setup(__props) {

  const dataCar = ref<carData | null>(null);
  const additionalFields = ref<additionalCosts>({
    expeditionCost: 320,
    certification: 160,
    parkingCost: 50,
    customsCost: 0,
    towingCost: 850,
    serviceCost: 0,
    pensionCost: 0,
  });

  onMounted(async () => {
    dataCar.value = await getSession('car');
    additionalFields.value = await getSession('additionalFields');
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CalculatorSearchCar, {
    "car-data": dataCar.value,
    additionalFields: additionalFields.value
  }, null, 8, ["car-data", "additionalFields"]))
}
}

})